export default __webpack_public_path__ + "static/media/text-sharer-logo.8bc5bdf6.png";